module.exports = __webpack_public_path__ + "img/isolated-monochrome-white.79a051cd.svg";